<div class="shr-modal">
    <div class="shr-modal-body">
        <span (click)="close()" class="shr-close">x</span>
        <ng-content></ng-content>
    </div>
</div>
<div class="shr-modal-background"></div>